package org.matthewo.datasource

import org.matthewo.api.EventTeamMatch
import org.matthewo.api.Schedule
import org.matthewo.schema.isCRI

object DataSource {
    fun eventURL(year: Int, code: String) = when {
        year.isCRI -> CRI.eventURL(year, code)
        else -> FTCEvents.eventURL(year, code)
    }

    fun resultsURL(year: Int, code: String, level: Schedule.Match.Level, number: Int, series: Int = -1) = when {
        year.isCRI -> CRI.resultsURL(year, code, level, number, series)
        else -> FTCEvents.resultsURL(year, code, level, number, series)
    }

    fun resultsURL(year: Int, code: String, match: Schedule.Match) =
        resultsURL(year, code, match.level, match.number, match.series)

    fun resultsURL(year: Int, match: EventTeamMatch) =
        resultsURL(year, match.code, match.level, match.number, match.series)
}
